export function computeGrossValue(netValue: number, vat?: number): number | undefined {
  return vat !== undefined ? netValue * (1 + vat / 100) : undefined;
}
